import {Animatable, Character, Combined, Object} from "../../../feature/project/Shot";
import {useAppDispatch} from "../../../feature/tools";
import {useParams} from "react-router-dom";
import {ElementContainer} from "./ElementContainer";
import {updateCharacter, updateObject} from "../../../feature/project/shotSlice";
import React, {useCallback, useEffect, useState} from "react";
import {AnimatableElement} from "./AnimatableElement";


export const SceneElement = (props: {
    editable: boolean,
    prefix: string,
    element: Combined & Animatable,
    type: string,
    play: boolean,
    onPlayEnd: () => void,
    selectedElement: Combined & Animatable | undefined,
    scale: number,
    onMove?: (info: { x: number, y: number, z: number, scale: number }) => void,
    onElementSelected: (element: Combined | undefined) => void
}) => {
    const dispatch = useAppDispatch()
    const {projectId, storyId} = useParams()

    const [played, setPlayed] = useState<Set<number>>(new Set())
    const [play, setPlay] = useState(props.play)
    const [bound, setBound] = useState<{
        left: number | undefined,
        top: number | undefined,
        right: number | undefined,
        bottom: number | undefined
    }>({left: undefined, top: undefined, right: undefined, bottom: undefined})
    useEffect(() => {
        if (played.size === ((props.element.layers?.length ?? 0) + 1) && play || 0 === ((props.element.layers?.length ?? 0) + 1) && play) {
            props.onPlayEnd()
            setPlayed(new Set())
            setPlay(false)
        }
    }, [played, play])

    useEffect(() => {
        setPlay(props.play)
    }, [props.play])

    useEffect(() => {

    }, [props.element.scale]);

    const elementRef = useCallback((node: HTMLDivElement) => {
        if (!node) return;
        setBound(prev => {
            const resizeObserver = new ResizeObserver(() => {
                const rect = node.getBoundingClientRect()
                setBound(prev => {
                    return {
                        left: (!prev.left || rect.left < prev.left) ? rect.left : prev.left,
                        top: (!prev.top || rect.top < prev.top) ? rect.top : prev.top,
                        right: (!prev.right || rect.right > prev.right) ? rect.right : prev.right,
                        bottom: (!prev.bottom || rect.bottom > prev.bottom) ? rect.bottom : prev.bottom
                    }
                })
            });
            resizeObserver.observe(node);
            return {
                left: undefined,
                top: undefined,
                right: undefined,
                bottom: undefined
            }
        })

    }, [props.element.scale, props.scale]);

    return (
        <ElementContainer
            editable={props.editable}
            key={props.prefix}
            isSelected={(props.selectedElement?.type === props.type && props.selectedElement?.id === props.element.id) || false}
            scale={props.scale}
            element={props.element}
            onMove={props.onMove}
            onPositionChanged={(position) => {
                const char = {
                    ...props.element,
                    x: position.x,
                    y: position.y
                }
                if (projectId) {
                    if (props.type === 'Object') {
                        dispatch(updateObject({
                            projectId: parseInt(projectId),
                            object: char as Object
                        }))
                    } else if (props.type === 'Character') {
                        dispatch(updateCharacter({
                            projectId: parseInt(projectId),
                            character: char as Character
                        }))
                    }
                }
            }}
            size={{
                width: ((bound.right ?? 0) - (bound.left ?? 0)) / props.scale / (props.element.scale ?? 1),
                height: ((bound.bottom ?? 0) - (bound.top ?? 0)) / props.scale / (props.element.scale ?? 1)
            }}
            onSelect={() => {
                props.onElementSelected(props.element)
            }}
        >
            <AnimatableElement
                element={{...props.element, x: 0, y: 0, z: 0, scale: 1}}
                play={props.play}
                scale={1}
                animations={props.element.animations && props.element.animations.length > 0 ? props.element.animations : []}
                onPlayEnd={(id: number) => {
                    if (play) {
                        setPlayed(prev => new Set(prev).add(id))
                    }
                }}>
                {props.element.layers && props.element.layers.length > 0 ?
                    props.element.layers.map(layer => {
                        return <AnimatableElement
                            element={layer}
                            play={props.play}
                            key={layer.id}
                            scale={layer.scale ?? 1}
                            animations={layer.animations && layer.animations.length > 0 ? layer.animations : [{id: -1}]}
                            onPlayEnd={(id: number) => {
                                if (play) {
                                    setPlayed(prev => new Set(prev).add(id))
                                }
                            }}
                        >
                            <div ref={elementRef}>
                                <img src={layer.source}
                                     draggable={false}
                                     unselectable={'on'}
                                />
                            </div>
                        </AnimatableElement>
                    }) : ''
                }
            </AnimatableElement>

        </ElementContainer>
    )
}